/**
 * Shared Andes registration status configuration.
 * Single source of truth for status→color, label, and indicator type mappings.
 *
 * Uses standard Andes lifecycle states as used across Amazon teams:
 * CREATED → UNRELEASED → ACTIVE → DEPRECATED → ARCHIVED → DELETED
 */

interface AndesStatusEntry {
  color: 'green' | 'grey' | 'red' | 'blue';
  label: string;
  indicatorType: 'success' | 'error' | 'pending' | 'in-progress' | 'stopped';
}

export const ANDES_STATUS_CONFIG: Record<string, AndesStatusEntry> = {
  CREATED:    { color: 'blue',  label: 'Created',     indicatorType: 'in-progress' },
  UNRELEASED: { color: 'blue',  label: 'Unreleased',  indicatorType: 'in-progress' },
  ACTIVE:     { color: 'green', label: 'Active',      indicatorType: 'success' },
  DEPRECATED: { color: 'grey',  label: 'Deprecated',  indicatorType: 'stopped' },
  ARCHIVED:   { color: 'grey',  label: 'Archived',    indicatorType: 'stopped' },
  DELETED:    { color: 'grey',  label: 'Deleted',     indicatorType: 'stopped' },
  FAILED:     { color: 'red',   label: 'Failed',      indicatorType: 'error' },
  // Backward compatibility: older FinTechADAADDAPTCodeGeneration package wrote REGISTERED instead of ACTIVE
  REGISTERED: { color: 'green', label: 'Registered',  indicatorType: 'success' },
};

const DEFAULT_STATUS: AndesStatusEntry = { color: 'grey', label: '', indicatorType: 'pending' };

export const getAndesStatus = (status: string): AndesStatusEntry =>
  ANDES_STATUS_CONFIG[status] ?? DEFAULT_STATUS;

/** Max characters before truncation */
export const ANDES_ERROR_TRUNCATE_LENGTH = 200;
